module.exports = __webpack_public_path__ + "static/Altero-Regular-a5493725a672113c877399ab83a26d51.woff2";